import React from 'react';

export default function ManualJournal() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Manual Journal</h1>
      <p className="text-gray-500">Halaman Manual Journal</p>
    </div>
  );
}
